import { render, staticRenderFns } from "./EditOrganizationPage.vue?vue&type=template&id=d67af6ac&"
import script from "./EditOrganizationPage.vue?vue&type=script&lang=js&"
export * from "./EditOrganizationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports